export enum FieldNames {
  Sectors = 'sectors',
  Sites = 'sites',
  // Takes precedence over Sites/siteId in the query when present.
  SiteArea = 'siteArea',
  Equipment = 'equipment',
  FormCategories = 'formCategories',
}
